import React from "react"
import './App.css';
import Routes from "./route";
import {connect} from 'react-redux'
import {hideLoader} from "./actions/loader";


class App extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.dispatch(hideLoader())
    }

    render() {
        let {isLoading, currentUser} = this.props;
        return (
            <div className="App">
                {isLoading ? <div className={'loader_outer_view'}>
                    <div className={'loader_inner'}>
                        <br/>
                        <div className={'spinnerText'}>
                            Loading
                        </div>
                    </div>
                </div> : null}

                <Routes {...this.props}/>

                <div id={'confirm-dialog'}></div>

            </div>
        );
    }
}

const mapStateToProps = ({global, router}) => ({
    isLoading: global.isLoading,
    currentUser: global.currentUser,
})
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(App)

